// extracted by mini-css-extract-plugin
export default {"text":"InfoRow_text__OnEdS"};